import React from 'react';
import SunEditor, { buttonList, SunEditorReactProps } from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import { BaseHelperText } from '../BaseTextField/BaseHelperText/BaseHelperText';

interface OwnProps {
  formikError?: string;
}

export const BaseSunEditor: React.FC<SunEditorReactProps & OwnProps> = (
  props,
) => {
  const { formikError, ...rest } = props;

  return (
    <>
      <div style={formikError ? { border: '1px solid #DE5753' } : {}}>
        <SunEditor
          setDefaultStyle="font-size: 16px; font-family: IBM Plex Sans;"
          showToolbar
          setOptions={{
            height: 200,
            fontSize: [36],
            buttonList: [
              ...buttonList.formatting,
              ['font', 'align', 'lineHeight'],
            ],
            // Other option
          }}
          {...rest}
        />
      </div>
      <BaseHelperText error style={{ marginTop: '-15px' }}>
        {formikError}
      </BaseHelperText>
    </>
  );
};
